<template>
    <div class="filter-panel" ref="filterPanel">
        <a href="#" @click.prevent="transitionOut" class="close-button"
            ><svg viewBox="0 0 7.8 7.8" xmlns="http://www.w3.org/2000/svg">
                <path d="m3.01 0h1.78v7.8h-1.78z" />
                <path d="m3.01 0h1.78v7.8h-1.78z" transform="matrix(0 1 -1 0 7.8 0)" /></svg
        ></a>
        <div class="filter-content" ref="filterContent">
            <div class="filter-section">
                <h3>Project Year</h3>
                <dropdown :options="projectsSelected" v-on:updateOption="onYearUpdated"></dropdown>
            </div>
            <div class="filter-section">
                <div class="two-column">
                    <div class="column">
                        <h3>Traffic</h3>
                        <label class="selection-radio" v-for="filter in trafficFilters">
                            <input type="radio" :value="filter.value" v-model="checkedTraffic" />
                            <span class="selection-dot"></span>
                            <span class="selection-label">{{ filter.name }}</span>
                        </label>
                    </div>
                    <div class="column">
                        <h3>Existing Surface</h3>
                        <label class="selection-radio" v-for="filter in surfaceFilters">
                            <input type="radio" :value="filter.value" v-model="checkedSurface" />
                            <span class="selection-dot"></span>
                            <span class="selection-label">{{ filter.name }}</span>
                        </label>
                    </div>
                </div>
                <div class="two-column">
                    <div class="column">
                        <h3>Overlay/Mix Type</h3>
                        <label class="selection-radio" v-for="filter in overlayFilters">
                            <input type="radio" :value="filter.value" v-model="checkedOverlay" />
                            <span class="selection-dot"></span>
                            <span class="selection-label">{{ filter.name }}</span>
                        </label>
                    </div>
                    <div class="column">
                        <h3>Specialty Application</h3>
                        <label class="selection-radio" v-for="filter in applicationFilters">
                            <input type="radio" :value="filter.value" v-model="checkedApplication" />
                            <span class="selection-dot"></span>
                            <span class="selection-label">{{ filter.name }}</span>
                        </label>
                    </div>
                </div>
                <div class="two-column">
                    <div class="column">
                        <h3>Agency Type</h3>
                        <label class="selection-radio" v-for="filter in agencyFilters">
                            <input type="radio" :value="filter.value" v-model="checkedAgency" />
                            <span class="selection-dot"></span>
                            <span class="selection-label">{{ filter.name }}</span>
                        </label>
                    </div>
                    <div class="column">
                        <h3>Rumble Strip</h3>
                        <label class="selection-radio" v-for="filter in stripFilters">
                            <input type="radio" :value="filter.value" v-model="checkedStrip" />
                            <span class="selection-dot"></span>
                            <span class="selection-label">{{ filter.name }}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="filter-section">
                <div class="two-column">
                    <div class="column">
                        <h3>Show<br />Previous Years</h3>
                        <label class="selection-switch">
                            <input type="checkbox" v-model="showPrevious" />
                            <span class="selection-slider"></span>
                        </label>
                    </div>
                    <div class="column">
                        <h3>Only Show<br />Project Stories</h3>
                        <label class="selection-switch">
                            <input type="checkbox" v-model="storiesOnly" />
                            <span class="selection-slider"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="filter-section">
                <button class="filter-button" @click.prevent="updateCurrentSelection">
                    <span>Submit</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from './Dropdown.vue';

export default {
    components: { Dropdown },
    props: {
        filterOpen: {
            type: Boolean,
            default: false
        },
        projectsSelected: {
            type: Array,
            default: null
        }
    },

    data() {
        return {
            trafficFilters: [
                { name: 'Interstate/Freeway', value: 'traffic-interstate-freeway' },
                { name: 'Rural Highway', value: 'traffic-rural-highway' },
                { name: 'Arterial/Collector', value: 'traffic-arterial-collector' },
                { name: 'Residential', value: 'traffic-residential' },
                { name: 'Airports', value: 'traffic-airports' },
                { name: 'None', value: null }
            ],
            overlayFilters: [
                { name: 'Fine-graded', value: 'overlay-fine-graded' },
                { name: 'Coarse-graded', value: 'overlay-coarse-graded' },
                { name: 'SMA', value: 'overlay-sma' },
                { name: 'Super-Pave 5', value: 'overlay-super-pave-5' },
                { name: 'None', value: null }
            ],
            agencyFilters: [
                { name: 'DOT', value: 'agency-dot' },
                { name: 'County', value: 'agency-county' },
                { name: 'Municipal-Private', value: 'agency-municipal-private' },
                { name: 'Federal', value: 'agency-federal' },
                { name: 'Airport', value: 'agency-airport' },
                { name: 'Military', value: 'agency-military' },
                { name: 'None', value: null }
            ],
            surfaceFilters: [
                { name: 'Asphalt-Milled', value: 'surface-asphalt-milled' },
                { name: 'Asphalt-New', value: 'surface-asphalt-new' },
                { name: 'Asphalt-Aged', value: 'surface-asphalt-aged' },
                { name: 'PCC', value: 'surface-pcc' },
                { name: 'None', value: null }
            ],
            applicationFilters: [
                { name: 'Racetrack', value: 'application-racetrack' },
                { name: 'Non-Centerline Application', value: 'application-non-centerline-application' },
                { name: 'Edgeline', value: 'application-edgeline' },
                { name: 'None', value: null }
            ],
            stripFilters: [
                { name: 'Centerline', value: 'strip-centerline' },
                { name: 'Edgeline', value: 'strip-edgeline' },
                { name: 'Both', value: 'strip-both' },
                { name: 'None', value: null }
            ],
            checkedTraffic: null,
            checkedOverlay: null,
            checkedAgency: null,
            checkedSurface: null,
            checkedApplication: null,
            checkedStrip: null,
            showPrevious: true,
            storiesOnly: false,
            selectedYear: null
        };
    },

    watch: {
        filterOpen: {
            immediate: false,
            handler(newVal, oldVal) {
                if (!newVal) {
                    this.transitionOut();
                } else {
                    this.transitionIn();
                }
            }
        },

        projectsSelected: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    // Set to latest (current) year
                    this.selectedYear = newVal[0];

                    // Reset everything
                    this.showPrevious = true;
                    this.storiesOnly = false;
                    this.checkedTraffic = null;
                    this.checkedOverlay = null;
                    this.checkedAgency = null;
                    this.checkedSurface = null;
                    this.checkedApplication = null;
                    this.checkedStrip = null;
                }

                // Kick things off
                if (!oldVal) {
                    this.updateCurrentSelection();
                }
            }
        }
    },

    methods: {
        transitionIn() {
            TweenLite.to(this.$refs['filterPanel'], 0.6, {
                autoAlpha: 1,
                transform: 'translateX(66.6666667%)',
                ease: Cubic.easeInOut,
                force3D: true
            });

            TweenLite.to(this.$refs['filterContent'], 0.4, {
                autoAlpha: 1,
                transform: 'translateX(0)',
                ease: Cubic.easeOut,
                force3D: true,
                delay: 0.4
            });
        },

        transitionOut() {
            TweenLite.to(this.$refs['filterContent'], 0.4, {
                autoAlpha: 0,
                transform: 'translateX(-20px)',
                ease: Cubic.easeOut,
                force3D: true
            });

            TweenLite.to(this.$refs['filterPanel'], 0.6, {
                autoAlpha: 0,
                transform: 'translateX(0)',
                ease: Cubic.easeInOut,
                force3D: true
            });

            this.$emit('filterClosed');
        },

        onYearUpdated(payload) {
            if (this.selectedYear !== payload) {
                this.selectedYear = payload;
            }
        },

        updateCurrentSelection() {
            //
            let filters = [];
            if (this.checkedTraffic !== null) {
                filters.push(this.checkedTraffic);
            }
            if (this.checkedOverlay !== null) {
                filters.push(this.checkedOverlay);
            }
            if (this.checkedAgency !== null) {
                filters.push(this.checkedAgency);
            }
            if (this.checkedSurface !== null) {
                filters.push(this.checkedSurface);
            }
            if (this.checkedApplication !== null) {
                filters.push(this.checkedApplication);
            }
            if (this.checkedStrip !== null) {
                filters.push(this.checkedStrip);
            }

            let payload = {
                selectedYear: this.selectedYear,
                showPrevious: this.showPrevious,
                storiesOnly: this.storiesOnly,
                filters: filters
            };

            console.log('FilterPanel: updateCurrentSelection', payload);
            this.$emit('filtersUpdated', payload);
        }
    },

    mounted() {}
};
</script>

<style scoped lang="scss">
.filter-panel {
    position: absolute;
    left: 0;
    z-index: 4000; // Make sure it acts as a modal above everything else
    opacity: 0;
    visibility: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 740px;
    background-color: #1f1f1f;
    margin: 0;
    transform: translateX(0);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 767px) {
        transform: translateX(0) !important;
    }

    @media screen and (min-width: 768px) {
        display: block;
        align-items: inherit;
        justify-content: inherit;
        z-index: 1000;
        border-radius: 0 7px 7px 0;
        margin: 0 0 0 -7px; // To account for 7px radius
        box-shadow: 0 0 15px rgba(#000, 0.2);
        right: inherit;
        bottom: inherit;
        top: 20px * 0.9;
        left: 20px * 0.9;
        width: 450px * 0.9;
        height: auto;
    }

    @media screen and (min-width: 1024px) {
        top: 20px;
        left: 20px;
        width: 450px;
    }

    .filter-content {
        position: relative;
        opacity: 0;
        transform: translateX(-15px);
        width: 100%;

        @media screen and (max-width: 767px) {
            transform: translateX(0) !important;
            max-width: 450px;
        }

        .filter-section {
            border-bottom: solid 1px rgba(#fff, 0.1);
            padding: 15px * 0.8 20px * 0.8 20px * 0.8 20px * 0.8;

            @media screen and (min-width: 768px) {
                padding: 15px * 0.9 20px * 0.9 20px * 0.9 (20px * 0.9 + 7px); // To account for 7px radius
            }

            @media screen and (min-width: 1024px) {
                padding: 15px 20px 20px (20px + 7px); // To account for 7px radius
            }

            &:first-child {
                margin-top: 15px;
            }

            &:last-child {
                border-bottom: none;
            }

            h3 {
                text-transform: uppercase;
                color: #727272;
                font-weight: 500;
                letter-spacing: 1px;
                font-size: 12px * 0.8;
                margin: 0 0 10px * 0.8 0;

                @media screen and (min-width: 768px) {
                    font-size: 12px * 0.9;
                    margin: 0 0 10px * 0.9 0;
                }

                @media screen and (min-width: 1024px) {
                    font-size: 12px;
                    margin: 0 0 10px 0;
                }
            }

            .selection-switch {
                position: relative;
                display: block;
                width: 48px;
                height: 28px;

                @media screen and (min-width: 768px) {
                    width: 54px;
                    height: 30px;
                }

                @media screen and (min-width: 1024px) {
                    width: 60px;
                    height: 34px;
                }

                input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }

                .selection-slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #272727;
                    border-radius: 30px;
                    transition: all 0.35s ease 0s;

                    @media screen and (min-width: 768px) {
                        border-radius: 32px;
                    }

                    @media screen and (min-width: 1024px) {
                        border-radius: 34px;
                    }

                    &:before {
                        position: absolute;
                        content: '';
                        height: 22px;
                        width: 22px;
                        left: 1px;
                        bottom: 3px;
                        background-color: #727272;
                        transition: all 0.35s ease 0s;
                        border-radius: 50%;

                        @media screen and (min-width: 768px) {
                            height: 24px;
                            width: 24px;
                            left: 3px;
                            bottom: 3px;
                        }

                        @media screen and (min-width: 1024px) {
                            height: 26px;
                            width: 26px;
                            left: 4px;
                            bottom: 4px;
                        }
                    }
                }
            }

            .selection-switch > input:checked + .selection-slider {
                background-color: #ff3a1e;
            }

            .selection-switch > input:checked + .selection-slider:before {
                background-color: #fff;
                transform: translateX(22px);

                @media screen and (min-width: 768px) {
                    transform: translateX(24px);
                }

                @media screen and (min-width: 1024px) {
                    transform: translateX(26px);
                }
            }

            .selection-radio {
                position: relative;
                display: flex;
                align-items: center;
                width: 100%;
                height: auto;
                cursor: pointer;

                input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }

                .selection-dot {
                    flex: 0 0 16px;
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    background-color: #000;
                    border: solid #373737 4px;
                    margin: 2px 10px 2px 0;
                    transition: all 0.35s ease 0s;

                    @media screen and (min-width: 1024px) {
                        flex: 0 0 18px;
                        width: 18px;
                        height: 18px;
                        border: solid #373737 5px;
                    }
                }

                .selection-label {
                    flex: 0 1 auto;
                    font-size: 14px * 0.8;
                    line-height: 18px * 0.8;
                    font-weight: 500;
                    margin: 0;
                    transition: all 0.35s ease 0s;
                    color: #fff;

                    @media screen and (min-width: 768px) {
                        font-size: 14px * 0.9;
                        line-height: 18px * 0.9;
                        margin: 0;
                    }

                    @media screen and (min-width: 1024px) {
                        font-size: 14px;
                        line-height: 18px;
                        margin: 0;
                    }
                }
            }

            .selection-radio > input:checked + .selection-dot {
                background-color: #ff3a1e;
            }

            .selection-radio > input:checked + .selection-dot + .selection-label {
                color: #ff3a1e;
            }

            .two-column {
                display: flex;
                margin-bottom: 20px;

                .column {
                    width: 50%;
                    flex: 0 1 50%;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .filter-button {
                position: relative;
                width: 100%;
                background: linear-gradient(#ff3a1e, #dc341c);
                border-radius: 5px;
                border: none;
                outline: none;

                padding: 15px * 0.8 20px * 0.8;
                margin: 5px auto 0 auto;
                cursor: pointer;
                display: block;
                text-decoration: none;
                line-height: 16px * 0.9;
                max-width: 250px;

                @media screen and (min-width: 768px) {
                    padding: 15px * 0.9 20px * 0.9;
                    line-height: 16px * 0.95;
                }

                @media screen and (min-width: 1024px) {
                    padding: 15px 20px;
                    line-height: 16px;
                }

                span {
                    font-size: 16px * 0.8;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    color: #fff;
                    text-transform: capitalize;
                    padding: 0;
                    transition: all 0.35s ease 0s;
                    display: block;

                    @media screen and (min-width: 768px) {
                        font-size: 16px * 0.9;
                    }

                    @media screen and (min-width: 1024px) {
                        font-size: 16px;
                    }
                }
            }
        }
    }

    .close-button {
        position: absolute;
        top: 20px * 0.8;
        right: 20px * 0.8;
        z-index: 1;

        @media screen and (min-width: 768px) {
            top: 20px * 0.9;
            right: 20px * 0.9;
        }

        @media screen and (min-width: 1024px) {
            top: 20px;
            right: 20px;
        }

        svg {
            width: 16px;
            height: 16px;
            display: block;
            transform: rotate(45deg);

            path {
                fill: #ff3a1e;
            }
        }
    }
}
</style>
